module.exports = __webpack_public_path__ + "img/home-bg-top.4fa24d3e.png";